import de from '@translations/de/deleteAccountPopup.json';
import en from '@translations/en/deleteAccountPopup.json';
import pl from '@translations/pl/deleteAccountPopup.json';
import sl from '@translations/sl/deleteAccountPopup.json';
import uk from '@translations/uk/deleteAccountPopup.json';
import bg from '@translations/bg/deleteAccountPopup.json';
import cz from '@translations/cz/deleteAccountPopup.json';
import fr from '@translations/fr/deleteAccountPopup.json';
import gr from '@translations/gr/deleteAccountPopup.json';
import it from '@translations/it/deleteAccountPopup.json';
import pr from '@translations/pr/deleteAccountPopup.json';
import ru from '@translations/ru/deleteAccountPopup.json';
import sk from '@translations/sk/deleteAccountPopup.json';
import sp from '@translations/sp/deleteAccountPopup.json';
import tr from '@translations/tr/deleteAccountPopup.json';
import hu from '@translations/hu/deleteAccountPopup.json';
import { ITranslations } from '@/types/common';
import { DeleteAccountPopupTransFields } from './types';

export const deleteAccountPopupTranslations: ITranslations<DeleteAccountPopupTransFields> = {
  name: 'deleteAccountPopup',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
